import { FeedDto } from 'api/dtos/associations/feed';
import { CursorPaginationParams } from 'api/types/associations/feed';
import bounceApiClient from 'legacy/common/utils/bounceApiClient';

export async function getOrganizationFeed(
  params: CursorPaginationParams & {
    organizationId: string;
    searchTerm?: string;
    useUnauthenticatedEndpoint?: boolean;
  }
): Promise<FeedDto> {
  const {
    organizationId,
    searchTerm,
    useUnauthenticatedEndpoint = false,
    ...paginationParams
  } = params;

  const cleanParams = Object.fromEntries(
    Object.entries({
      ...paginationParams,
      query: searchTerm
    }).filter(([_, value]) => value !== undefined)
  );

  const endpoint = useUnauthenticatedEndpoint
    ? `/service/organizations/${organizationId}/feeds/events`
    : `/api/groups/${organizationId}/feeds/events`;

  const { data } = await bounceApiClient.get(endpoint, {
    params: cleanParams
  });

  return data;
}

